<template>
  <div class="inputs">
    <v-btn @click="addInput">Add field</v-btn>
    <v-layout
      v-for="(field, index) in inputs"
      :key="`inputs-${index}`"
      wrap
      row
    >
      <v-flex xs8>
        <content-field
          v-model="inputs[index]"
          :type="type"
        />
      </v-flex>
      <v-flex xs3 offset-xs1>
        <v-btn class="red--text mt-3" @click="removeInput(index)">Delete</v-btn>
      </v-flex>
    </v-layout>
    <transition name="slide-from-top">
      <span v-if="isError" class="red--text">{{errorMessage}}</span>
    </transition>
  </div>
</template>

<script>
import ContentField from '@/components/shared/ContentField'
import { remove } from 'ramda'

export default {
  name: 'EContentFields',
  components: {
    ContentField
  },
  props: {
    type: {
      type: String,
      default: 'text'
    },
    inputsValues: {
      type: Array,
      default: []
    },
    isError: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: 'Something wrong with values in inputs'
    }
  },
  data () {
    return {
      inputs: []
    }
  },
  watch: {
    inputs () {
      this.$emit('input', this.inputs)
    }
  },
  methods: {
    addInput () {
      this.inputs.push('')
    },
    removeInput (index) {
      this.inputs = remove(index, 1, this.inputs)
    }
  },
  mounted () {
    this.inputs = this.inputsValues
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/EContentFields/index.vue